import { get, post } from "src/services/api";

export const uploadDirectToStorage = async (accountId, assistantId, files) => {
  const formData = new FormData();

  if (Array.isArray(files)) {
    files.forEach(file => formData.append("files", file));
  } else {
    formData.append("files", files);
  }

  const endpoint = `/accounts/${accountId}/assistants/${assistantId}/file-storage`;

  const response = await post({
    endpoint,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });

  return response;
};

export const getFileFromStorage = async (accountId, assistantId, filePath, fileName) => {
  const endpoint = `/accounts/${accountId}/assistants/${assistantId}/file-storage`;
  const params = { filePath, fileName };

  return await get({ endpoint, params });
};

export default {
  uploadDirectToStorage,
  getFileFromStorage
};
